/* eslint-disable import/no-extraneous-dependencies */
import { useContext } from "react";

// SERP AND CDP CONTEXT
import { CategoryContext } from "@lululemon/ecom-cdp/src/containers/category-page-context";

import { SignalContext } from "@lululemon/ecom-common/src/services/context-service";

// USED TO COMBINE CONTEXT OF SERP AND CDP
const useParseContext = () => {
  const CDPContext = useContext(CategoryContext);
  // TODO MOVE THIS TO SERP OR CDP CONTEXT
  const FusionSignalContext = useContext(SignalContext);
  // THESE ARE FIELDS USED ON THE ONE PAGE BUT NOT THE OTHER
  // NEED TO SET DEFAULTS IN ORDER TO AVOID ERRORS
  // THIS WILL BE FIXED WHEN WE REFACTOR SERP
  const SERPDefaults = {
    handlePartialLoading: () => {},
    isSERP: true,
    trackFilterClick: () => {},
    braQuizButtonURL: "",
    // For SERP, lwApi flag is always true so it's safe to set default value to true.
    // Also, To make it work with new SERP we need fusionSerp as true as default as SearchContext HOC is not available in SERP
    fusionSerp: true,
  };
  const CDPDefaults = {
    isNoFollowAll: false,
    isSERP: false,
    fusionSerp: false,
  };

  if (CDPContext) {
    return { ...CDPDefaults, ...CDPContext, ...FusionSignalContext };
  }
  return { ...SERPDefaults, ...FusionSignalContext };
};

export default useParseContext;
